import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-setting-assignment',
  templateUrl: './setting-assignment.template.html',
  styleUrls: [],
})
export class SettingAssignmentComponent implements OnInit {
  // 'shared' = Xử lý chung | 'specific' = Phân công cụ thể
  public assignmentConfig: string = 'shared'; 

  constructor(
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.loadConfig();
  }

  loadConfig() {
    // Tạm thời lấy từ localStorage trong lúc chờ API thực tế
    const storedConfig = localStorage.getItem('wm_assignment_config');
    if (storedConfig) {
      this.assignmentConfig = storedConfig;
    }
  }

  saveConfig() {
    // Tạm thời lưu vào localStorage
    localStorage.setItem('wm_assignment_config', this.assignmentConfig);
    this.toastr.success('Lưu cấu hình phân công thành công');
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-assignment/setting-assignment.component.ts